export default "<div class=\"chart-container\">\r\n  <canvas id=\"chartBar{{idCanvas}}\" #chart ></canvas>\r\n</div>\r\n"